import React,{useEffect, useState} from 'react';
import useFetch from '../CustomHooks/useFetch';

import Logo from '../Images/HappyTableLogo8.png';
import '../Styles/Login.scss';

import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';





export default function PasswordChanger () {

    const [response, fetchData] = useFetch();
    const [status, setStatus] = useState('Verifying');
    
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [newPasswordAgain, setNewPasswordAgain] = useState('');
    const [errorMessages, setErrorMessages] = useState({email:'',yourName: '', restaurantName : '', oldPassword : '', newPassword :'', newPasswordAgain : ''});

    const setErrorMessage = (key, value) =>{
        setErrorMessages( {...errorMessages, [key] : value});
    }


    useEffect(
        ()=> {
            async function f() {
               if(response != null) {
                   if(response.length != 0) {
                        if(response){   
                            setStatus('Verified');         
                        } else {
                            setStatus('Rejected');    
                        }
                   }
               }
           }
           f();
       },[response]
   )

   const submitForm = async (e) => {
    
    e.preventDefault();
    let validated = true;

    if (newPassword != newPasswordAgain) {
        setErrorMessage('newPasswordAgain', 'Re-enter your password confirmation so it matches your password.');
        validated = false;
    }
    else {
        setErrorMessage('newPasswordAgain', '');
    }

    
    if(validated) {
        fetchData(
            {
                url: '/admin/auth/change-password',
                method: 'PUT',
                postData: {
                    oldPassword: oldPassword,
                    newPassword: newPassword,
                    newPasswordRetype: newPasswordAgain,
                },
                addTokenHeader: true,
            }
        )
    }
}
    
    return (
       <div className="login">
            <div className="login__inner-wrapper">
                {response.length == 0 ?
                    <React.Fragment>
                        <div style={{fontSize: '1.5rem'}}>Change password</div>
                        <div style={{ marginTop: '20px' }}>Please type your new password twice.</div>
                        <TextField id="oldPassword" type="password" label="Old password" value={oldPassword} onChange={(e)=> setOldPassword(e.target.value)}  helperText={errorMessages.oldPassword} error={errorMessages.oldPassword == ''? false : true}/>
                        <TextField id="newPassword" type="password" label="New password" value={newPassword} onChange={(e)=> setNewPassword(e.target.value)}  helperText={errorMessages.newPassword} error={errorMessages.newPassword == ''? false : true}/>
                        <TextField id="passwordAgain" type="password" label="New password again" value={newPasswordAgain} onChange={(e)=> setNewPasswordAgain(e.target.value)}  helperText={errorMessages.newPasswordAgain} error={errorMessages.newPasswordAgain == ''? false : true}/>
                        <Button id="submitButton" variant="contained" color="primary" style={{marginTop:'30px'}} onClick={submitForm}>
                            Change password
                        </Button>
                    </React.Fragment>
                    : null}
                {response.length != 0 && response ?
                    <div>We have sucessfully changed your password.</div>
                : null}
                {response.length != 0 && !response ?
                <div>Can not change your password. Please contact support.</div>
                : null}
            </div>
        </div>
    )
}

function LoginLink(){
    return (
        <React.Fragment>
            <a href="/Login">Login</a>
        </React.Fragment>
    )
}
